export const mapOptionsCreator = (map: {
  ControlPosition: { RIGHT_CENTER: any; TOP_RIGHT: any }
  ZoomControlStyle: { SMALL: any }
  MapTypeId: { ROADMAP: any }
}) => {
  return {
    gestureHandling: 'greedy',
    fullscreenControl: false,
    zoomControl: false,
    mapTypeControl: false,
    mapTypeId: map.MapTypeId.ROADMAP,
  }
}
